/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mins_UnitInputs */



/**
* | output |
* | --- |
* | "min(s)" |
*
* @param {Mins_UnitInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const mins_unit = /** @type {((inputs?: Mins_UnitInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mins_UnitInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("min")
	if (locale === "de") return /** @type {LocalizedString} */ ("min(s)")
	if (locale === "it") return /** @type {LocalizedString} */ ("minuti")
	if (locale === "ru") return /** @type {LocalizedString} */ ("мин(с)")
	if (locale === "es") return /** @type {LocalizedString} */ ("min(s)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("最小值")
	if (locale === "ja") return /** @type {LocalizedString} */ ("分")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मिनट(ओं)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("min(s)")
	return /** @type {LocalizedString} */ ("min(s)")
});